import { RoleEnum } from '@/types/enums/role.enum';
import type { KeyWithFilter } from '@/utils/filter/filter';

export const filters = (): KeyWithFilter[] => [
    {
        key: [
            { key: 'name', trans: 'name', defaultOperator: 'like' },
            {
                key: 'serialNumber',
                trans: 'serialNumber',
                defaultOperator: 'like',
            },
            { key: 'address', trans: 'address', defaultOperator: 'like' },
            { key: 'rfid', trans: 'rfid', defaultOperator: 'like' },
            {
                key: 'contractCode',
                trans: 'contractCode',
                defaultOperator: 'like',
            },
        ],
        type: 'input',
        value: [],
    },
    {
        key: [
            {
                key: 'createdDate',
                trans: 'createdDate',
                defaultOperator: '=',
            },
            {
                key: 'installationDate',
                trans: 'installationDate',
                defaultOperator: '=',
            },
        ],
        type: 'date',
        value: [],
    },
    {
        key: [
            {
                key: 'id',
                trans: 'device',
                keyService: 'Devices',
                defaultOperator: '=',
            },
            {
                key: 'customerId',
                trans: 'Customers',
                keyService: 'Customers',
                defaultOperator: '=',
                excludeRoles: [RoleEnum.CUSTOMER],
            },
            {
                key: 'deviceSKUId',
                trans: 'deviceSKU',
                keyService: 'DeviceSKUs',
                defaultOperator: '=',
            },
        ],
        type: 'orm',
        value: [],
    },
];
